"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _mergeRefs = require("./merge-refs");
Object.keys(_mergeRefs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mergeRefs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mergeRefs[key];
    }
  });
});